<template>
    <page>
        <module :title="id ? '编辑储值送活动' : '新建储值送活动'">
            <c-form ref="form">
                <c-form title="基础信息">
                    <c-form-item type="hidden" name="id" v-model="activityId"></c-form-item>
                    <c-form-item type="input" label="活动名称" name="activity_name" required></c-form-item>
                    <c-form-item type="number" label="充值金额" name="recharge_amount" required input-unit="元" word="充值金额不能小于0元" :limit="[0,]" decimal="0"></c-form-item>
                    <c-form-item type="datetime" label="活动时间" start-name="begin_date" end-name="end_date" required></c-form-item>
                    <c-form-item type="checkbox" label="可售范围" name="visible_user_type" :options="userLevelOptions" required
                                 word="选中则表示该等级会员可以享受当前活动优惠"></c-form-item>
                </c-form>

                <c-form title="免费穿商品">
                    <c-form-item>
                        <m-operate border>
                            <c-button color="gray" hollow @click="$refs.productSelector.open()">添加商品</c-button>
                            <div style="padding-left: 12px;width: auto;" class="c-form-item-word">规则说明：以下商品任选一件</div>
                        </m-operate>
                        <c-table ref="productList" v-model="productList" height="auto" :paging="false" border>
                            <c-table-column label="商品信息" name="productName" width="250">
                                <template v-slot="{data}">
                                    <div class="flex-center">
                                        <c-image :src="oss(data.productImgUrl, 46, 46)" size="46" preview></c-image>
                                        <p class="flex-grow ellipsis-2" style="margin-left: 12px;">
                                            {{ data.productName }}
                                        </p>
                                    </div>
                                </template>
                            </c-table-column>
                            <c-table-column label="商品价格" name="productPrice" width="100">
                                <template v-slot="{data}">￥{{ data.productPrice }}</template>
                            </c-table-column>
                            <c-table-column type="button" fixed="right" label="操作" width="100">
                                <template v-slot="row">
                                    <c-table-button @click="row.remove()">删除</c-table-button>
                                </template>
                            </c-table-column>
                        </c-table>

                    </c-form-item>
                </c-form>
            </c-form>

            <template slot="button">
                <c-button size="m" @click="submit()">提交保存</c-button>
            </template>
        </module>

        <product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>
    </page>
</template>

<script>
import productSelector from '@/components/service/product_selector.vue';

export default {
    name: 'recharge_bonus_edit',

    components: {
        productSelector
    },

    props: {
        id: String
    },

    data() {
        return {
            activityId: '',
            levelPrices:[],
            productList: [],
            stateOptions: [
                { name: '启用', value: 1 },
                { name: '禁用', value: 0 }
            ],
            userLevelOptions: []
        };
    },

    watch: {
        id() {
            this.getRechargeBonusDetail();
        }
    },

    mounted() {
        this.initUserLevelOptions();
        this.id && this.getRechargeBonusDetail();
    },

    methods: {
        //加载会员等级列表
        initUserLevelOptions(){
            this.request({
                url: '/user_level/options',
                data: {},
                success: data => {
                    this.userLevelOptions = Array.from(data, item => {
                        return {
                            name: item.name,
                            value: item.value
                        }
                    });
                }
            });
        },
        getRechargeBonusDetail() {
            this.request({
                url: '/recharge_bonus/detail',
                data: { id: this.id },
                loading: true,
                success: data => {
                    this.$refs.form.set(data);
                    this.activityId = data.id;
                    this.productList = data.product_list.map(item => ({
                        productId: item.product_id,
                        productName: item.product_name,
                        productImgUrl: item.product_img_url,
                        productPrice: item.product_price,
                        productItemNumber: item.product_itemnumber
                    }));
                }
            });
        },

        productSelectHandle(list) {
            list = list.filter(item => {
                return !this.productList.find(row => row.productId === item.product_id);
            });

            const formattedList = list.map(item => ({
                productId: item.product_id,
                productName: item.product_name,
                productImgUrl: item.product_img_url,
                productPrice: item.product_price,
                productItemNumber: item.product_itemnumber
            }));

            this.productList = this.productList.concat(formattedList);
        },

        submit() {
            this.$refs.form.submit({
                url: this.id ? '/recharge_bonus/edit' : '/recharge_bonus/add',
                rule: {
                    activity_name: '请填写活动名称',
                    recharge_amount: '请填写充值金额',
                    begin_date: '请选择活动时间',
                    end_date: '请选择活动时间',
                    visible_user_type: '请选择活动可售范围',
                    products: [{
                        type: 'function',
                        fun: () => this.productList.length >= 1,
                        word: '请至少添加1个商品'
                    }],
                },
                dataFormatter: data => {
                    if (this.id) {
                        data.id = this.id;
                    }
                    data.visible_user_type = data.visible_user_type?data.visible_user_type.join(','):'';
                    data.product_list = this.productList.map(item => ({
                        product_id: item.productId
                    }));

                    return data;
                },
                success: () => {
                    this.$message({ text: '保存成功' });
                    this.$bus.$emit('m_recharge_bonus.update',{});
                    this.redirectTo('/recharge_bonus');
                }
            });
        }
    }
};
</script>
